// src/components/Footer.jsx
import React from 'react'
import { Link } from 'react-router-dom'
import { FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa'
import PremiumLogo from './PremiumLogo'
import './Footer.css'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <PremiumLogo size={48} ariaLabel="Logo de Flotte" />
          <div className="footer__brand-text">
            <p className="footer__brand-title">Flotte</p>
            <p className="footer__brand-copy">
              La plataforma para coordinar proveedores confiables, visibilidad operativa y datos en
              toda tu red logística.
            </p>
            <div className="footer__contact">
              <a href="mailto:hola@flotte.com.mx">
                <FaEnvelope aria-hidden="true" /> hola@flotte.com.mx
              </a>
              <span>
                <FaMapMarkerAlt aria-hidden="true" /> CDMX, México
              </span>
            </div>
          </div>
        </div>

        <div className="footer__links">
          <div className="footer__column">
            <p className="footer__column-title">Empresa</p>
            <ul>
              <li><Link to="/sobre-nosotros">Sobre nosotros</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contacto">Contacto</Link></li>
            </ul>
          </div>
          <div className="footer__column">
            <p className="footer__column-title">Producto</p>
            <ul>
              <li><Link to="/marketplace">Marketplace</Link></li>
              <li><Link to="/marketplace/vendor">Vender en Flotte</Link></li>
              <li><Link to="/tarifas">Planes y precios</Link></li>
            </ul>
          </div>
          <div className="footer__column">
            <p className="footer__column-title">Legal</p>
            <ul>
              <li><Link to="/terminos">Términos de uso</Link></li>
              <li><Link to="/privacidad">Aviso de privacidad</Link></li>
              <li><Link to="/cookies">Cookies</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <span>© {currentYear} Flotte Marketplace. Todos los derechos reservados.</span>
        <div className="footer__bottom-links">
          <Link to="/terminos">Términos</Link>
          <Link to="/privacidad">Privacidad</Link>
        </div>
      </div>
    </footer>
  )
}
